import i18n from "../../../i18n";
import { required, same, validateError } from "../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setIsLoading as setIsLoadingApp } from "../../../app.logic";
import { putField, conditionFormChecker } from "../../../utils/form";
import store from "../../../store";
import { Input, notification } from "ant-design-vue";
import { createFieldInputNumber } from "../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

export const callMeChangePassword = ({ form, otp }) => {
    otp.otp = form.otp
    return store.dispatch(`resource/v1/security/user/meChangePassword`, { data: { oldPassword: form.presentPassword, newPassword: form.newPassword, otp: otp } })
};

export const callEmailOtpGenertate = ({ form }) => store.dispatch(`resource/v1/security/emailToken/generate`, { data: form });
    
export const callOtpGenertate = ({ form }) => store.dispatch(`resource/v1/security/otp/generate`, { data: form });

export const onClickChangePassword = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callMeChangePassword({ form: data.form, otp:data.otp }).finally(() => setIsLoadingApp(false));
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        presentPassword: null,
        newPassword: null,
        confirmPassword: null,
        otp: null,
        mobile: null,
        mobileShow: null,
    };
};

export const createRules = ({ data }) => {
    return {
        presentPassword: [required],
        newPassword: [required],
        confirmPassword: [
            required,
            same(data.form, "newPassword", i18n.global.t("views.changePassword.newPassword"), i18n.global.t("views.changePassword.confirmPassword")),
        ],
        otp: [required]
    };
};

export const createField = ({ data }) => {
    const dirty = {};
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        {
            key: "presentPassword",
            visible: () => true,
            colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label();
                return (
                    <Input.Password
                        value={modelRef.presentPassword}
                        onUpdate:value={(value) => (modelRef.presentPassword = value)}
                        placeholder={placeholder}
                    ></Input.Password>
                );
            },
            label: () => i18n.global.t("views.changePassword.presentPassword"),
        },
        {
            key: "newPassword",
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label();
                const onBlur = () => {
                    if (dirty["confirmPassword"]) {
                        useForm.validate("confirmPassword").catch(() => {});
                    }
                    useForm.validate("newPassword").catch(() => {});
                };
                return (
                    <Input.Password
                        value={modelRef.newPassword}
                        onUpdate:value={(value) => (modelRef.newPassword = value)}
                        onBlur={onBlur}
                        placeholder={placeholder}
                    ></Input.Password>
                );
            },
            label: () => i18n.global.t("views.changePassword.newPassword"),
        },
        {
            key: "confirmPassword",
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            inputRender: ({ field }) => {
                const placeholder = field.label();
                const onBlur = () => {
                    dirty["confirmPassword"] = true;
                    useForm.validate("confirmPassword").catch(() => {});
                };
                return (
                    <Input.Password
                        value={modelRef.confirmPassword}
                        onUpdate:value={(value) => (modelRef.confirmPassword = value)}
                        onBlur={onBlur}
                        placeholder={placeholder}
                    ></Input.Password>
                );
            },
            label: () => i18n.global.t("views.changePassword.confirmPassword"),
        },
    ];
};

export const createFieldOtp = ({ props, data }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;

    return putField({
        data,
        fields: [
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "otp",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.otp.otp"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.otp,
                            "onUpdate:value": (value) => (modelRef.otp = value),
                            disabled: viewOnly,
                            comma: false,
                            maxDecimal: 6,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ],
    });
};

export const loadForm = ({ props, data }) => {
    const { dataProp } = props;
    const { personTypeByKey } = dataProp;
    data.color="color:null"
    data.useForm.modelRef = props.dataProp
    let promise = null
    console.log(data.useForm.modelRef)
    if (!"1".includes(personTypeByKey)) {
        promise = callOtpGenertate({ form: data.useForm.modelRef }).catch((error) => {
            if (error.response?.data.message === "error.v1OtpService.estimated") {
                data.isWaitApprove = true;
            }
            validateError({ error });
            throw error;
        });
    } else if ("1".includes(personTypeByKey)) {
        promise = callEmailOtpGenertate({ form: data.useForm.modelRef }).catch((error) => {
            validateError({ error });
            throw error;
        });
    } else {
        notification["error"]({ message: i18n.global.t("model.securityEvent.error") });
    }
    return promise
        .then((otp) => data.otp = otp)
        .then(() => {
            data.isGenOtp = false;
            data.timeGen = 180;
            const interval = setInterval(() => {
                data.timeGen--;
                if (data.timeGen < 1) {
                    data.isGenOtp = true
                    clearInterval(interval);
                }
                if (data.timeGen < 79) {
                    data.color = "color:red"
                }
            }, 1000);
        });
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    data.fieldOtp = createFieldOtp({ props, data, refs });
    loadForm({ props, data, refs });
};

export const resend = ({ props, data, refs }) => {
    loadForm({ props, data, refs }).then(() => notification["success"]({ message: i18n.global.t("views.otp.resendSuccess") }));
};
